export default __webpack_public_path__ + "static/media/13.37920633.jpg";